import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { sellCar, sellCarFailed, sellCarSuccess } from "./slice";

//--------------------sellCarSaga-------------------------

function* sellCarSaga(action: ReturnType<typeof sellCar>): any {
  try {
    const fd = action.payload;
    const response = yield call(request.post, endpoints.sellMyCar, fd);
    yield put(sellCarSuccess(response));
  } catch (error: any) {
    yield put(sellCarFailed(error));
  }
}

function* sellCarSagas() {
  yield all([takeLatest(sellCar, sellCarSaga)]);
}

export { sellCarSagas };
